"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty.js");

var _objectWithoutProperties = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _excluded = ["color"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconPerson = void 0;

var React = __importStar(require("react"));

exports.IconPerson = React.forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, _excluded);

  return React.createElement("svg", _objectSpread(_objectSpread({
    width: "31",
    height: "40",
    viewBox: "0 0 31 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    ref: forwardedRef
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0953 19.9979H11.2591C1.98584 19.9979 -0.108022 27.9753 0.00420322 31.964V35.9913L0.0041727 39.0024C0.0041727 39.0024 0.429158 40 0.949773 40L29.2941 39.94C29.6707 39.8027 30.4236 39.368 30.4236 38.7273V31.9264C30.4236 24.8619 26.8177 19.9979 20.0953 19.9979ZM11.2591 21.9967H13.1468H18.2147H20.0953C26.6094 21.9967 28.6802 27.3104 28.6802 31.9264V37.9861L24.7365 38.0049C24.575 37.035 24.7365 32.9987 24.7365 32.9987C24.7365 32.3692 24.3537 31.9864 23.9931 31.9864C23.4725 31.9864 23.1196 32.4477 23.1233 32.9987V38.0461C23.0347 38.0163 22.9427 38.0049 22.8507 38.0049H8.01534V32.9987C8.02242 32.4363 7.58682 31.979 7.05559 31.9864C6.53497 31.9864 6.12067 32.4477 6.12421 32.9987V38.0049H1.89556V31.964C1.89556 26.4216 6.0567 21.9967 11.2591 21.9967Z",
    fill: color
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6788 0C11.0182 0 7.22168 4.04234 7.22168 8.99972C7.22168 13.9534 11.0182 17.9994 15.6788 17.9994C20.3431 17.9994 24.136 13.9534 24.136 8.99972C24.136 4.04234 20.3431 0 15.6788 0ZM15.6788 1.99866C19.316 1.99866 22.2483 5.11855 22.2449 8.99972C22.2449 12.8809 19.316 15.997 15.6788 15.997C12.0452 15.997 9.10928 12.8809 9.10928 8.99972C9.10928 5.11855 12.0452 1.99866 15.6788 1.99866Z",
    fill: color
  }));
});